import { color } from '../../themer/theme/color';

export const theme = {
	duration: 1000,
	height: '4px',
	colors: [color.background.light, color.highlight, color.text.hover],
};
